import React from "react";

/**  Lazy loading components for improved performance
*   React.lazy is used to dynamically import components when they are needed
*/

export const UserCalorie = React.lazy(() => import("./UserCalorie/index.page"));
export const PublicUserNutritionDetails = React.lazy(() => import("./UserNutritionDetails/index.page"));

